import { NOTIFICATION } from "../_constants/actionConstants";

const addNotificationAction = newNotification => ({
  type: NOTIFICATION.ADD_NOTIFICATION,
  payload: newNotification
});

const signalRActions = {
  addNotificationAction
};

export default signalRActions;
